export var getMaxWidth = function getMaxWidth(isFluid) {
  return isFluid ? '100%' : '640px';
};